import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Button } from '../../components/ui/button';
import { Lock, User, Eye, EyeOff, RefreshCw } from 'lucide-react';

export default function LoginScreen({ onLogin }) {
  const [loginData, setLoginData] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoggingIn(true);
    setLoginError('');
    const errMsg = await onLogin(loginData);
    if (errMsg) setLoginError(errMsg);
    setIsLoggingIn(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-orange-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md shadow-2xl">
        <CardHeader className="text-center pb-8">
          <div className="w-16 h-16 bg-amber-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="w-8 h-8 text-white" />
          </div>
          <CardTitle className="text-2xl font-bold text-gray-900">Painel Administrativo</CardTitle>
          <p className="text-gray-600 mt-2">PoliTalks · Eleições 2026</p>
        </CardHeader>
        <CardContent>
          {loginError && (
            <div className="mb-6 p-4 rounded-lg bg-red-50 border border-red-200">
              <p className="text-red-700 text-sm font-medium" data-testid="login-error">{loginError}</p>
            </div>
          )}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="username" className="text-sm font-semibold text-gray-700">Usuário</Label>
              <div className="relative mt-2">
                <User className="w-5 h-5 absolute left-3 top-3 text-gray-400" />
                <Input id="username" name="username" type="text" required disabled={isLoggingIn}
                  value={loginData.username} onChange={(e) => setLoginData({ ...loginData, username: e.target.value })}
                  className="pl-10" placeholder="Digite o usuário" data-testid="login-username" />
              </div>
            </div>
            <div>
              <Label htmlFor="password" className="text-sm font-semibold text-gray-700">Senha</Label>
              <div className="relative mt-2">
                <Lock className="w-5 h-5 absolute left-3 top-3 text-gray-400" />
                <Input id="password" name="password" type={showPassword ? 'text' : 'password'} required disabled={isLoggingIn}
                  value={loginData.password} onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                  className="pl-10 pr-10" placeholder="Digite a senha" data-testid="login-password" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-3 text-gray-400 hover:text-gray-600">
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
            </div>
            <Button type="submit" disabled={isLoggingIn} className="w-full bg-amber-500 hover:bg-amber-600 text-white py-3 text-lg font-semibold" data-testid="login-submit">
              {isLoggingIn
                ? <span className="flex items-center gap-2"><RefreshCw className="w-5 h-5 animate-spin" /> Verificando...</span>
                : 'Entrar no Painel'}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
